import { render, staticRenderFns } from "./quickWithdrawalBenefit.vue?vue&type=template&id=b17f870c&scoped=true&"
import script from "./quickWithdrawalBenefit.vue?vue&type=script&lang=js&"
export * from "./quickWithdrawalBenefit.vue?vue&type=script&lang=js&"
import style0 from "./quickWithdrawalBenefit.vue?vue&type=style&index=0&id=b17f870c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17f870c",
  null
  
)

export default component.exports